<template>

  <v-container
    v-if="rate && costs && sales && rooms && cancellation_policies && payment_policies && rate_types && meals"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title v-once>
        {{rate.name || 'Create'}}
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="rate.name" class="ma-1" label="Nume" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rate.contract_id" class="ma-1" :items="contracts" label="Contract" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rate.cancellation_policy_id" class="ma-1" :items="cancellation_policies" label="Politică de anulare" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rate.payment_policy_id" class="ma-1" :items="payment_policies" label="Politică de plată" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rate.status" class="ma-1" :items="[{id: 'active', name: 'Activat'}, {id: 'inactive', name: 'Dezactivat'}]" item-text="name" item-value="id" label="Status" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Tip</div>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rate.type" class="ma-1" :items="rate_types" label="Tip" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-checkbox v-model="rate.static.editable_pricings" class="ma-1 pa-0" color="primary" label="Plan tarifar cu pret editabil" hide-details :ripple="false"/>
          </v-col>
          <v-col cols="12">
            <v-checkbox v-model="extended" class="ma-1 pa-0" color="primary" label="Bazat pe un plan tarifar existent" hide-details :ripple="false"/>
          </v-col>
          <v-col cols="12">
            <v-select v-if="extended" v-model="rate.parent_id" class="ma-1" :items="(rate.type === 'cost') ? costs : [...costs, ...sales]" item-text="name" item-value="id" label="Plan tarifar extins" outlined dense hide-details/>
          </v-col>
          <v-col cols="4">
            <v-select v-if="extended && rate.parent_id" v-model="rate.static.formula.operation" class="ma-1" :items="[{id: 'add', name: 'Adaugă'}, {id: 'subtract', name: 'Scade'}]" item-text="name" item-value="id" label="Metoda de calcul" outlined dense hide-details/>
          </v-col>
          <v-col cols="4">
            <v-text-field v-if="extended && rate.parent_id" v-model="rate.static.formula.value" class="ma-1" label="Valoare" type="number" outlined dense hide-details/>
          </v-col>
          <v-col cols="4">
            <v-select v-if="extended && rate.parent_id" v-model="rate.static.formula.type" class="ma-1" :items="[{id: 'percent', name: 'Procent'}, {id: 'flat', name: 'Moneda'}]" item-text="name" item-value="id" label="Tip valoare" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Tipuri de Camere</div>
            <v-item-group v-model="rate.room_type_ids" multiple>
              <v-item v-for="room in rooms.data" :key="room.id" :value="room.id" v-slot:default="{ active, toggle }">
                <v-btn depressed :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{room.name}}<sub><small>ID:({{room.id}})</small></sub></v-btn>
              </v-item>
            </v-item-group>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Tipuri de Masa</div>
            <v-item-group v-model="rate.meals" multiple>
              <v-item v-for="meal in meals" :key="meal.id" :value="meal.id" v-slot:default="{ active, toggle }">
                <v-btn depressed :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{meal.name}}</v-btn>
              </v-item>
            </v-item-group>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="rate.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>


<script>

  import room_repository from '@/repositories/room-repository'
  import rate_repository from '@/repositories/rate-repository'
  import contract_repository from '@/repositories/contract-repository'
  import policy_repository from '@/repositories/policy-repository'
  import config_repository from '@/repositories/config-repository'

  export default {
    data: () => ({
      rate: null,

      costs: null,
      sales: null,
      rooms: null,
      contracts: null,
      cancellation_policies: null,
      payment_policies: null,
      rate_types: null,
      meals: null,

      extended: false,
      individual: false,
      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    async created() {
      rate_repository.getRate(this.$route.params.hotel, this.$route.params.rate).then(r => this.rate = r);
      rate_repository.getCosts(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}).then(r => this.costs = r);
      rate_repository.getSales(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}).then(r => this.sales = r);
      room_repository.getRooms(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}).then(r => this.rooms = r);
      contract_repository.getContracts(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}, {dropdown: true}).then(r => this.contracts = r);
      policy_repository.getCancellationPolicies(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}, {dropdown: true}).then(r => this.cancellation_policies = r);
      policy_repository.getPaymentPolicies(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER, page: 1}, {dropdown: true}).then(r => this.payment_policies = r);
      config_repository.getRateTypes().then(r => this.rate_types = r);
      config_repository.getMeals().then(r => this.meals = r);

      this.extended = Boolean(this.rate.parent_id !== null);
    },

    methods: {

      save: async function () {
        try {
          this.saving = true;

          if (!this.extended)
            this.rate.parent_id = null;

          this.rate = await rate_repository.saveRate(this.$route.params.hotel, this.rate);
          await this.$store.dispatch('alert/success', 'Success');
          this.$route.params.supplier === 'create' ? await this.$router.push(`/hotels/${this.$route.params.hotel}/rates/${this.rate.id}`) : null;
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
        }
      },

      destroy: async function () {
        try {
          this.deleting = true;
          await rate_repository.destroyRate(this.$route.params.hotel, this.rate.id);
          await this.$router.push(`/hotels/${this.$route.params.hotel}/rates`);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }

    }
  }
</script>